import React from "react";
import { COLORS } from "../constants";
import { pill, fontSerif } from "./styles";

export default function ControlsHint({ mode }) {
  return (
    <div
      data-testid="zone-controls-hint"
      style={{
        position: "absolute",
        bottom: 22,
        left: 24,
        color: COLORS.ivory,
        fontFamily: fontSerif,
        fontSize: 12,
        letterSpacing: 1,
        ...pill,
        padding: "10px 16px",
        maxWidth: 340,
        lineHeight: 1.7,
      }}
    >
      <div
        style={{
          color: COLORS.gold,
          fontSize: 10,
          letterSpacing: 3,
          marginBottom: 4,
          textTransform: "uppercase",
        }}
      >
        Navigation
      </div>
      {mode === "walk" ? (
        <>
          <div>
            <span style={{ color: COLORS.goldBright }}>WASD</span> / Arrows · move &nbsp;·&nbsp;
            <span style={{ color: COLORS.goldBright }}>Shift</span> · sprint
          </div>
          <div>
            <span style={{ color: COLORS.goldBright }}>Mouse</span> · look &nbsp;·&nbsp;{" "}
            <span style={{ color: COLORS.goldBright }}>Esc</span> · release
          </div>
          <div style={{ opacity: 0.7, marginTop: 4 }}>
            Click anywhere to lock the pointer.
          </div>
        </>
      ) : (
        <>
          <div>
            <span style={{ color: COLORS.goldBright }}>Drag</span> · orbit &nbsp;·&nbsp;{" "}
            <span style={{ color: COLORS.goldBright }}>Right-drag</span> · pan
          </div>
          <div>
            <span style={{ color: COLORS.goldBright }}>Scroll</span> · zoom &nbsp;·&nbsp;{" "}
            <span style={{ color: COLORS.goldBright }}>Click</span> · hotspots
          </div>
        </>
      )}
    </div>
  );
}
